import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpAccordionPanel, DtpAccordionGroup } from 'dtp-react-components';
import { Input, Grid, Button, Radio } from '../../components';
import Masks from '../../utils/masks';
import {
  tipoEntidade,
} from '../../utils/listsSelect';
import {
  doGet,
} from '../../utils/requests';

class FiltroRelatorio extends Component {
  constructor() {
    super();
    this.state = {
      competenciaInicial: '',
      competenciaFinal: '',
      tipoEntidade: null,
      uf: null,
      'destinatario-rpps': null,
      superintendencia: null,
      gex: null,
      aps: null,
      ente: null,
      listaSuperintendencias: [],
      listaGexs: [],
      listaAps: [],
      listaEntes: [],
      relacao: 'todos',
    };
  }

  componentDidMount() {
    this.carregaUnidadesOrganicas(24, null, this.carregaSuperintendencias);
  }

  getValidationState = () => {
    const d1 = this.state.competenciaInicial;
    const d2 = this.state.competenciaFinal;

    if ((d1.length !== 6 && d1.length !== 0) || (d2.length !== 6 && d1.length !== 0)) {
      return 'error';
    }

    const d1Ano = parseInt(d1.substring(2, 6), 10);
    const d2Ano = parseInt(d2.substring(2, 6), 10);
    const d1Mes = parseInt(d1.substring(0, 2), 10);
    const d2Mes = parseInt(d2.substring(0, 2), 10);

    if (d1Mes > 12 || d2Mes > 12) {
      return 'error';
    }

    if ((d2Ano < d1Ano) || (d2Ano === d1Ano && d2Mes < d1Mes)) {
      return 'error';
    }
    let months = (d2Ano - d1Ano) * 12;
    months -= d1Mes;
    months += d2Mes;
    if (months > 12 || months < 0) {
      return 'error';
    }
    return 'active';
  }

  radioRelacao = [
    {
      label: 'Todos',
      value: 'todos',
    },
    {
      label: 'Solicitante',
      value: 'solicitante',
    },
    {
      label: 'Destinatário',
      value: 'destinatario',
    },
  ]

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    }, () => this.trataFormulario(name));
  }

  handleChangeRadio = (value) => {
    this.setState({ relacao: value });
  };

  trataFormulario = (campoAlterado) => {
    if (campoAlterado === 'tipoEntidade') {
      this.setState({ 'destinatario-rpps': null, uf: null });
    }
    if (campoAlterado === 'uf') {
      this.setState({ 'destinatario-rpps': null });
    }
    if (campoAlterado === 'superintendencia') {
      this.setState({ gex: null, aps: null, ente: null });
      if (this.state.superintendencia) {
        this.carregaUnidadesOrganicas(3, this.state.superintendencia, this.carregaGexs);
      }
    }
    if (campoAlterado === 'gex') {
      this.setState({ aps: null, ente: null });
      if (this.state.gex) {
        this.carregaUnidadesOrganicas(4, this.state.gex, this.carregaAps);
      }
    }
    if (campoAlterado === 'aps') {
      this.setState({ ente: null });
      if (this.state.aps) {
        this.carregaEntesFederativos(this.state.aps);
      }
    }
  }

  listaFiltradaDestinatarios = () => {
    const listaParticipantes = this.props.destinatarios.filter((item) => {
      if (item.tipoRegimeProprio === this.state.tipoEntidade &&
        ((item.uf && this.state.tipoEntidade === 2) ? item.uf === this.state.uf : true)) {
        return item;
      }
      return null;
    });
    return listaParticipantes;
  }

  carregaUfDosMunicipios = () => {
    const listaUf = [];
    this.props.destinatarios.forEach((item) => {
      if (item.uf && !listaUf.find(itemLista => itemLista.value === item.uf)) {
        listaUf.push({
          label: item.uf,
          value: item.uf,
        });
      }
    });
    listaUf.sort((a, b) => {
      if (a.value > b.value) {
        return 1;
      }
      if (a.value < b.value) {
        return -1;
      }
      return 0;
    });
    return listaUf;
  }

  addMessage = (text) => {
    const message = {
      title: 'Titulo',
      text,
      timeout: 5000,
      type: 'danger',
    };
    window.DtpSnackbar.addMessage(message);
  };

  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        if (error.status === 404) {
          this.addMessage('Nenhum resultado encontrado para o filtro informado.');
        } else {
          this.addMessage(`${data.mensagem}`);
        }
      } else {
        this.addMessage('Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.');
      }
    }
  };

  carregaUnidadesOrganicas = (categoria, codigoSuperior, sucesso) => {
    const parametros = {};
    if (codigoSuperior) {
      parametros.codigoSuperior = codigoSuperior;
    }
    if (categoria) {
      parametros.categoria = categoria;
    }

    doGet('unidades-organicas', sucesso, this.tratarErro, parametros);
  }

  carregaSuperintendencias = (response) => {
    const superintendencias = [];
    response.data.forEach((item) => {
      superintendencias.push({
        label: item.nomeUnidade,
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaSuperintendencias: superintendencias });
  }

  carregaGexs = (response) => {
    const gexs = [];
    response.data.forEach((item) => {
      gexs.push({
        label: item.nomeUnidade,
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaGexs: gexs });
  }

  carregaAps = (response) => {
    const aps = [];
    response.data.forEach((item) => {
      aps.push({
        label: item.nomeUnidade,
        value: item.codigoUnidade,
      });
    });
    this.setState({ listaAps: aps });
  }

  carregaEntesFederativos = (aps) => {
    const parametros = { aps };

    doGet('entes-federativos', this.tratarSucessoEntesFederativos, this.tratarErro, parametros);
  }

  tratarSucessoEntesFederativos = (response) => {
    const entes = [];
    response.data.forEach((item) => {
      entes.push({
        label: item.nomeRpps,
        value: item.idParticipante,
      });
    });
    this.setState({ listaEntes: entes });
  }
  montaFiltrosDefault = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="3 3 3 3">
          <Input
            integer
            mask={Masks.compet}
            label="* Competência Inicial"
            value={this.state.competenciaInicial}
            onChange={e => this.handleChange(e, 'competenciaInicial')}
            validationState={this.getValidationState()}
          />
        </Grid>
        <Grid cols="3 3 3 3">
          <Input
            integer
            mask={Masks.compet}
            label="* Competência Final"
            value={this.state.competenciaFinal}
            onChange={e => this.handleChange(e, 'competenciaFinal')}
            validationState={this.getValidationState()}
          />
        </Grid>
      </div>
      {!this.state.tipoEntidade && this.props.filtroModalidade && this.props.rgps ? (
        <div className="row">
          <Grid cols="4 4 4 4">
            <Radio
              value={this.state.relacao}
              name="Relação"
              itemList={this.radioRelacao}
              onChange={value => this.handleChangeRadio(value)}
            />
          </Grid>
        </div>
      ) : ''}
      {!this.state.tipoEntidade && this.props.rgps ? (
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              label="Superintendência"
              onChange={e => this.handleChange(e, 'superintendencia')}
              placeholder="Todas"
              value={this.state.superintendencia}
              itemList={this.state.listaSuperintendencias}
              custom
            />
          </Grid>
          {this.state.superintendencia ? (
            <Grid cols="4 4 4 4">
              <Input
                label="GEX"
                onChange={e => this.handleChange(e, 'gex')}
                placeholder="Todas"
                value={this.state.gex}
                itemList={this.state.listaGexs}
                custom
              />
            </Grid>
              ) : ''}
          {this.state.gex ? (
            <Grid cols="4 4 4 4">
              <Input
                label="APS"
                onChange={e => this.handleChange(e, 'aps')}
                placeholder="Todas"
                value={this.state.aps}
                itemList={this.state.listaAps}
                custom
              />
            </Grid>
              ) : ''}
        </div>
      ) : ''}
      <div className="row">
        {this.state.aps ? (
          <Grid cols="4 4 4 4">
            <Input
              label="Ente Federativo"
              onChange={e => this.handleChange(e, 'ente')}
              placeholder="Todos"
              value={this.state.ente}
              itemList={this.state.listaEntes}
              custom
            />
          </Grid>
            ) : ''}
      </div>
      {!this.state.superintendencia && this.props.rgps ? (
        <div className="row">
          <Grid cols="4 4 4 4">
            <Input
              label="Entidade"
              onChange={e => this.handleChange(e, 'tipoEntidade')}
              placeholder="Selecione a entidade"
              value={this.state.tipoEntidade}
              itemList={tipoEntidade}
              custom
              number
            />
          </Grid>
          {this.state.tipoEntidade === 2 ? (
            <Grid cols="4 4 4 4">
              <Input
                label="UF"
                onChange={e => this.handleChange(e, 'uf')}
                placeholder="Selecione a UF"
                value={this.state.uf}
                itemList={this.carregaUfDosMunicipios()}
                custom
              />
            </Grid>
              ) : ''}
          {this.state.tipoEntidade ? (
            <Grid cols="4 4 4 4">
              <Input
                label="Destinatário"
                name="destinatario-rpps"
                onChange={e => this.handleChange(e, 'destinatario-rpps')}
                placeholder="Selecione o destinatário"
                value={this.state['destinatario-rpps']}
                itemList={this.listaFiltradaDestinatarios()}
                custom
              />
            </Grid>
              ) : ''}
        </div>
        ) : ''}
    </React.Fragment>
  )

  handleSearch = () => {
    this.props.handleSearchFilter(this.state);
  }

  render() {
    const filtrosPesquisa = this.montaFiltrosDefault();
    if (!filtrosPesquisa) {
      return null;
    }
    return (
      <DtpAccordionGroup>
        <DtpAccordionPanel
          headingId="relatorio"
          panelId="filtro-relatorio"
          icon="ico-filter"
          title={`Filtro de Relatório de ${this.props.tipo}`}
        >
          {filtrosPesquisa}
          <div className="row">
            <Button
              className="dtp-primary right"
              title="Pesquisar"
              onClick={() => this.handleSearch()}
              hint="Pesquisar de acordo com o filtro aplicado"
            />
          </div>
        </DtpAccordionPanel>
      </DtpAccordionGroup>
    );
  }
}

FiltroRelatorio.propTypes = {
  handleSearchFilter: PropTypes.func,
}.isRequired;

export default FiltroRelatorio;



// WEBPACK FOOTER //
// ./src/pages/relatorios/FiltroRelatorio.jsx